import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    TITLE: {
        id: 'LoadingError.title',
        defaultMessage: 'Loading error.',
    },
    DESCRIPTION: {
        id: 'LoadingError.desc',
        defaultMessage: 'Could not fetch data from the server.',
    },
});

export default enumMessages;
